import { render, staticRenderFns } from "./View8.vue?vue&type=template&id=39de1b0a"
import script from "./View8.vue?vue&type=script&lang=js"
export * from "./View8.vue?vue&type=script&lang=js"
import style0 from "./View8.vue?vue&type=style&index=0&id=39de1b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports